module.exports = {"610829001":"宋家川街道","610829101":"辛家沟镇","610829102":"郭家沟镇","610829103":"寇家塬镇","610829104":"岔上镇","610829105":"张家山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610829.json
// module id = 3007
// module chunks = 0